// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSInternalMessageCard/index.less
// module id = 962
// module chunks = 42